import { Form } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { langList } from '../factories/Utils'
import { Lang } from '../models/Lang'
import { computeFormItemName } from './localizable/utils'

interface FormItemErrorsProps {
  name: NamePath
  namePrefix?: NamePath
}

const FormItemErrors = ({ namePrefix, name }: FormItemErrorsProps) => (
  <Form.Item noStyle shouldUpdate>
    {({ getFieldError }) => {
      // on récupère les erreurs pour firstName et lastName
      const errorsByLang: { lang: Lang; errors: string[] }[] = langList
        .map((lang) => ({
          lang,
          errors: getFieldError(
            computeFormItemName(namePrefix, name, lang.code)
          ),
        }))
        .filter((e) => e.errors.length)

      if (errorsByLang.length === 0) return <></>

      return (
        <div style={{ marginBottom: 24 }}>
          {errorsByLang.map(({ lang, errors }) =>
            errors.map((error, i) => (
              <div key={`${name}-${i}`} style={{ color: 'red' }}>
                {lang.flag} {error}
              </div>
            ))
          )}
        </div>
      )
    }}
  </Form.Item>
)

export default FormItemErrors
